import { render, staticRenderFns } from "./BlogGridPage.vue?vue&type=template&id=934a39a0&"
import script from "./BlogGridPage.vue?vue&type=script&lang=js&"
export * from "./BlogGridPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports